import { EnterNewPhoneTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const EnterNewPhoneTrackingSchema: Record<
  EnterNewPhoneTrackingPoint,
  string
> = {
  [EnterNewPhoneTrackingPoint.PageView]: '3e478bc6-ad54-47d4-9003-84cd8a5aec13',
  [EnterNewPhoneTrackingPoint.NextButtonClick]:
    '8a3f2af3-8f4b-4d79-a621-825aa095d7cf',
  [EnterNewPhoneTrackingPoint.BackButtonClick]:
    '12170ab2-3b91-4609-9393-7916c581c420',
  [EnterNewPhoneTrackingPoint.HelpButtonClick]:
    '149e2fba-fa73-41a2-8cbe-a0da4b26bacb',
};

export const getEnterNewPhonePageTypeAndSchema = (
  trackingPoint: EnterNewPhoneTrackingPoint
) => {
  return {
    page_type: PageType.EnterNewPhonePage,
    schema: EnterNewPhoneTrackingSchema[trackingPoint],
  };
};
